export default __webpack_public_path__ + "static/media/Dickcatz-GoldAward.a681065e.svg";